import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bpi.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { debounceTime } from "rxjs";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { CreateApplicationLocationBpiConstants } from "./create-application-location-bpi.constants";
import { takeUntil } from "rxjs/operators";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import Query from "@arcgis/core/rest/support/Query";
import { CreateApplicationLocationBpConstants } from "../../bp/create-application-location-bp/create-application-location-bp.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
let CreateApplicationLocationBpiComponent = class CreateApplicationLocationBpiComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    requestStatusService;
    modalService;
    changeDetectorRefs;
    propertiesForm;
    detailsFormGroupName = CreateApplicationLocationBpiConstants.DETAILS_FORM_GROUP_NAME;
    propertiesFormGroupName = CreateApplicationLocationBpiConstants.PROPERTIES_FORM_GROUP_NAME;
    descriptionLabel1 = CreateApplicationLocationBpiConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBpiConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBpiConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationBpiConstants.DESCRIPTION_LABEL_4;
    propertiesFormControlName = CreateApplicationLocationBpiConstants.PROPERTIES_FORM_CONTROL_NAME;
    validationMessages = CreateApplicationLocationBpiConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationBpiConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBpiConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBpiConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBpiConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBpiConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBpiConstants.ADDRESS_CONTROL;
    erfSizeControl = CreateApplicationLocationBpiConstants.ERF_SIZE_CONTROL;
    titleDeedControl = CreateApplicationLocationBpiConstants.TITLE_DEED_CONTROL;
    ownerControl = CreateApplicationLocationBpiConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBpiConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBpiConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBpiConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBpiConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBpiConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBpiConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationBpiConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    titleDeedTextPlaceHolder = CreateApplicationLocationBpiConstants.TITLE_DEED_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    ownerLabel = CreateApplicationLocationBpiConstants.OWNER_LABEL;
    propertiesHeading = CreateApplicationLocationBpiConstants.PROPERTY_HEADING_LABEL;
    selectedPropertySubscription;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneDocMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owners";
    mapComponent;
    isMapLoaded = false;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    copyApplicantToOwnerLabel = CreateApplicationLocationBpiConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    showPropertyForm = false;
    hasBpamsReferenceNumberFormControlName = CreateApplicationLocationBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    hasBpamsReferenceNumber = false;
    modalOptions = {
        size: "lg",
        centered: true,
        keyboard: false,
        backdrop: "static"
    };
    constructor(createApplicationService, aflaModuleStrategyService, recipientListService, appController, mapService, requestStatusService, modalService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.modalService = modalService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.subscribeToProperty();
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(defaults.simulateApplicantFilterGroupObjects);
        }
        else {
            this.getMetadata();
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        if (this.hasBpamsReferenceNumber) {
            this.mapService.actionPropertyEnabled = true;
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        const propertyControl = this.propertiesForm.get("properties");
        if (propertyControl.length === 0) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(null, [Validators.required]),
                subdivision: new FormControl(null, [Validators.required]),
                allotment: new FormControl(null, [Validators.required]),
                farmNo: new FormControl(null, [Validators.required]),
                sgCode: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                erfSize: new FormControl(null, [Validators.required]),
                titleDeed: new FormControl(null, [Validators.required]),
                geometry: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null, [Validators.required]),
            });
            propertyControl.push(newProperty);
        }
        return propertyControl;
    }
    updateRequiredFields() {
        const propertyControlArray = this.propertiesForm.get(this.propertiesFormControlName);
        const propertyControl = propertyControlArray.controls[0];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
        this.propertiesForm = form;
        const propertyControl = this.propertiesForm.get(this.propertiesFormControlName);
        if (propertyControl.length === 0) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(null, [Validators.required]),
                subdivision: new FormControl(null, [Validators.required]),
                allotment: new FormControl(null, [Validators.required]),
                farmNo: new FormControl(null, [Validators.required]),
                sgCode: new FormControl(null, [Validators.required]),
                address: new FormControl(null, [Validators.required]),
                erfSize: new FormControl(null, [Validators.required]),
                titleDeed: new FormControl(null, [Validators.required]),
                geometry: new FormControl(null),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null, [Validators.required]),
            });
            propertyControl.push(newProperty);
        }
        const hasBpamsReferenceNumber = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.hasBpamsReferenceNumberFormControlName).value;
        if (hasBpamsReferenceNumber !== undefined && hasBpamsReferenceNumber !== null && hasBpamsReferenceNumber.toLowerCase() === "yes") {
            this.hasBpamsReferenceNumber = false;
        }
        else {
            this.hasBpamsReferenceNumber = true;
        }
    }
    syncMapGeometries() {
        const geometries = [];
        const propertyControl = this.propertiesForm.get("properties");
        propertyControl.controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans graphics", true);
            this.showPropertyForm = true;
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).pipe(takeUntil(this._destroy$)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControlArray = this.propertiesForm.get("properties");
        const propertyControl = propertyControlArray.controls[0];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        this.showPropertyForm = true;
        if ((erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") || (farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "")) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    propertyControlArray.clear();
                    this.mapComponent.clearGraphics("Building plans graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        const propertiesFormArray = this.propertiesForm.get("properties");
        propertiesFormArray.clear();
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        const newProperty = new FormGroup({
            erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
            subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
            allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
            farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
            sgCode: new FormControl(sgCode, [Validators.required]),
            address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
            erfSize: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfSize", "erfsize"), [Validators.required]),
            titleDeed: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeed, titledeed"), [Validators.required]),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
            owners: new FormControl(null, [Validators.required]),
        });
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
            + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                this.getPropertyOwners(sgCode, newProperty);
            },
            error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateApplicationLocationBpConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateApplicationLocationBpConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.propertiesForm.get("properties");
                propertyControl.push(newProperty);
                this.updateRequiredFields();
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.propertiesForm.get("properties");
            propertyControl.push(newProperty);
            this.updateRequiredFields();
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    onBtnCopyApplicantToOwnerClicked() {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const propertyControl = this.propertiesForm.get("properties");
        const ownersFormControl = propertyControl.controls[0].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: NgbModal },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBpiComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-bpi",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationBpiComponent);
export { CreateApplicationLocationBpiComponent };
